import * as React from "react"
import List from "@mui/material/List"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import Checkbox from "@mui/material/Checkbox"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
// import { LotBarcodeT } from "."
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid2, Typography } from "@mui/material"
import { ChipStyled, Stack } from "src/shared/components"
import OutlinedInput from "src/shared/components/outlined-input"
import { Settings as SettingsIcon, ExpandMore as ExpandMoreIcon } from "@mui/icons-material"

export interface LotBarcodeT {
  actionId?: string | null
  batchExpiry?: string | null
  batchNumber?: string | null
  product: {
    name?: string | null
  }
}
function not(a: readonly string[], b: readonly string[]) {
  return a.filter((value) => !b.includes(value))
}

function intersection(a: readonly string[], b: readonly string[]) {
  return a.filter((value) => b?.includes(value))
}

export default function TransferList({
  lotBarcodes,
  onActionIdsSelection
}: {
  lotBarcodes: LotBarcodeT[]
  onActionIdsSelection: (actionsIds: string[]) => void
}) {
  const [queryNotSelected, setQueryNotSelected] = React.useState("")
  const [querySelected, setQuerySelected] = React.useState("")
  const [labelSettingsExpanded, setLabelSettingsExpanded] = React.useState(true)
  const actionIds = React.useMemo(() => {
    return lotBarcodes.map((item) => item.actionId)?.filter(Boolean) as string[]
  }, [lotBarcodes])

  const [checked, setChecked] = React.useState<readonly string[]>([])
  const [left, setLeft] = React.useState<readonly string[]>([])
  const [right, setRight] = React.useState<string[]>([])

  React.useEffect(() => {
    onActionIdsSelection(right)
  }, [right])
  React.useEffect(() => {
    if (actionIds?.length && !left?.length) {
      setLeft(actionIds)
    }
  }, [actionIds])
  const leftChecked = intersection(checked, left)
  const rightChecked = intersection(checked, right)

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setChecked(newChecked)
  }

  const handleAllRight = () => {
    setRight(right.concat(left))
    setLeft([])
  }

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked))
    setLeft(not(left, leftChecked))
    setChecked(not(checked, leftChecked))
  }

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked))
    setRight(not(right, rightChecked))
    setChecked(not(checked, rightChecked))
  }

  const handleAllLeft = () => {
    setLeft(left.concat(right))
    setRight([])
  }

  const customList = (items: readonly string[]) => (
    <Paper sx={{ height: 450, overflow: "auto", background: (theme) => theme?.palette?.secondary?.light }}>
      {/* <Grid2 container role="list"> */}
      <List role="list">
        {items.map((value: string) => {
          const labelId = `transfer-list-item-${value}-label`
          return (
            // <Grid2 size={{ xs: 6 }}>
            <ListItemButton key={value} role="listitem" onClick={handleToggle(value)}>
              <ListItemIcon sx={{ minWidth: "0px !important" }}>
                <Checkbox
                  checked={checked.includes(value)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    "aria-labelledby": labelId
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value} />
            </ListItemButton>
            // </Grid2>
          )
        })}
      </List>
      {/* </Grid2> */}
    </Paper>
  )

  return (
    // <Paper elevation={1} sx={{ p: 2, borderRadius: 2, border: "1px solid #e0e0e0" }}>
    <Accordion
      expanded={labelSettingsExpanded}
      onChange={(_, isExpanded) => setLabelSettingsExpanded(isExpanded)}
      // sx={{ borderRadius: 2, border: "1px solid #e0e0e0" }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6" sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <SettingsIcon />
            Configuration
          </Typography>
          <ChipStyled
            label={`${right?.length ?? 0} Selected`}
            size="small"
            color="primary"
            variant="outlined"
            sx={{ ml: 2 }}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Grid2 container spacing={2} sx={{ justifyContent: "center", alignItems: "center" }}>
          <Grid2 size={{ sm: 5.5 }}>
            <Stack mb={2}>
              <OutlinedInput
                value={queryNotSelected}
                onChange={(e) => setQueryNotSelected(e.target.value)}
                placeholder="Enter Action id"
                label={"Search Items not Selected."}
                sx={{
                  ".MuiOutlinedInput-notchedOutline": { border: (theme) => `1px solid ${theme.palette.primary.main}` }
                }}
                // sx={{ border: (theme) => `1px solid ${theme?.palette?.primary?.main}` }}
              />
            </Stack>
            {customList(left?.filter((val) => val.includes(queryNotSelected)))}
          </Grid2>
          <Grid2 size={{ sm: 1 }}>
            <Grid2 container direction="column" sx={{ alignItems: "center" }}>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleAllRight}
                disabled={left.length === 0}
                aria-label="move all right"
              >
                ≫
              </Button>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleCheckedRight}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
              >
                &gt;
              </Button>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleCheckedLeft}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
              >
                &lt;
              </Button>
              <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleAllLeft}
                disabled={right.length === 0}
                aria-label="move all left"
              >
                ≪
              </Button>
            </Grid2>
          </Grid2>
          <Grid2 size={{ sm: 5.5 }}>
            <Stack mb={2}>
              <OutlinedInput
                value={querySelected}
                onChange={(e) => setQuerySelected(e.target.value)}
                placeholder="Enter Action id"
                label={"Search Items Selected."}
                sx={{
                  ".MuiOutlinedInput-notchedOutline": { border: (theme) => `1px solid ${theme.palette.primary.main}` }
                }}
                // sx={{ border: (theme) => `1px solid ${theme?.palette?.primary?.main}` }}
              />
            </Stack>
            {customList(right?.filter((val) => val.includes(querySelected)))}
          </Grid2>
        </Grid2>
      </AccordionDetails>
    </Accordion>
    // </Paper>
  )
}
